// routes
export const LOGIN_ROUTE = '/login';
export const PROJECTS_ROUTE = '/projects';
export const CENTRAL_ROUTE = '/central/:centralID';
export const ADMIN_ROUTE = '/admin';